import axios from 'axios';
import AlertDialog from '@global/helpers/alertDialog';

const miniCartModule = {
  namespaced: true,
  state: {
    dataIsLoad: false,
    totalCount: 0, // 所有溫藏商品總數
    generalCount: 0, // 常溫總數量
    refrigerationCount: 0, // 冷藏總數量
    freezingCount: 0, // 冷凍總數量,
    generalMarketProducts: [],
    refrigerationMarketProducts: [],
    freezingMarketProducts: [],
    temperaturesData: [],
    count: 0, // 所有商品總數(for 一頁式)
    hotSearch: [],
    hotLoad: false,
  },
  mutations: {
    changeCartTotalCount(state, itemArray) {
      state.totalCount = itemArray.data.Response.TotalCount;
      state.count = itemArray.data.Response.TotalCount;
      state.temperaturesData = itemArray.data.Response.Temperatures;
      // 溫層ID (0: 常溫，1: 冷藏，2: 常溫)
      itemArray.data.Response.Temperatures.forEach((item) => {
        if (item.ID === 0) {
          state.generalCount = item.Count;
          state.generalMarketProducts = item.Markets;
        } else if (item.ID === 1) {
          state.refrigerationCount = item.Count;
          state.refrigerationMarketProducts = item.Markets;
        } else {
          state.freezingCount = item.Count;
          state.freezingMarketProducts = item.Markets;
        }
      });
      state.dataIsLoad = true;
    },
  },
  actions: {
    getCartInfo({ state, commit }) {
      state.dataIsLoad = false;
      axios.get(API_URL.CART_INFO).then((res) => {
        if (res.data.Code === 200 || res.data.Code === 406) {
          commit('changeCartTotalCount', res);
          // 更新購物車商品數量
          commit('cartModule/changeCartTotalCount', res, { root: true });
        }
      });
    },
    getHotSearch({ state, commit }) {
      state.hotLoad = false;

      axios
        .get(API_URL.HOT_SEARCH, {
          params: {
            period: 'range',
            date: 'last3',
            limit: 10,
          },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              const hotArray = [];
              for (let i = 0; i < res.data.Response.length; i++) {
                hotArray.push(res.data.Response[i]);
              }
              state.hotSearch = hotArray;
              state.hotLoad = true;
            }
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
  },
  getters: {
    isOnlyOneTemp(state) {
      let hasProductTempCount = 0;
      if (state.generalCount > 0) {
        hasProductTempCount += 1;
      }
      if (state.refrigerationCount > 0) {
        hasProductTempCount += 1;
      }
      if (state.freezingCount > 0) {
        hasProductTempCount += 1;
      }
      return hasProductTempCount === 1;
    },
  },
};

export default miniCartModule;
